import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "checklist-docs__list" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "checklist-docs__doc-text" }
const _hoisted_4 = { class: "checklist-docs__doc-title" }
const _hoisted_5 = { class: "checklist-docs__doc-subtitle" }
const _hoisted_6 = { class: "checklist-docs__footer" }

import { useTemplateRef } from 'vue'

import { ChecklistView } from '@/models/checklist'
import type { ListItem } from '@/models/interfaces'

import BasePopup from '@/components/ui/BasePopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChecklistDocsPopup',
  props: {
    checklist: {},
    docs: {}
  },
  setup(__props: any, { expose: __expose }) {



const basePopup = useTemplateRef('popup')

async function show(): Promise<void> {
  basePopup.value?.show()
}

__expose({
  show,
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BasePopup, {
    ref: "popup",
    class: "checklist-docs",
    title: "Choose a book",
    compact: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.docs, (doc) => {
          return (_openBlock(), _createElementBlock("li", {
            key: doc.id,
            class: "checklist-docs__doc-wrapper"
          }, [
            _createVNode(_component_router_link, {
              class: "checklist-docs__doc",
              to: `/app/book/${doc.url_slug}/preview`
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "checklist-docs__doc-cover",
                  src: doc.cover_image,
                  width: "54",
                  height: "72",
                  alt: ""
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(doc.title), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(doc.author), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          class: "checklist-docs__link",
          to: { name: 'books' }
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Browse the full library", -1)
          ]))]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "iconfont iarrow" }, null, -1))
      ])
    ]),
    _: 1
  }, 512))
}
}

})